import styled from "styled-components";

export const UpdatesContainer = styled.div`
  padding: 0;
`;

export const StyledTextContainer = styled.div``;

export const StyledAlgorithmLogo = styled.img`
  min-width: 40px;
  width: 40px;
  height: 40px;
  margin: ${({ theme }) => theme.space.xs} ${({ theme }) => theme.space.sm} 0 0;
`;
